<template>
  <section class="card-profile-admin">
    <h3 v-if="card.adminNotes || pendingSales.length > 0" class="section-header secondary-font">
      Admin
    </h3>

    <template v-if="loaded">
      <p v-if="card.adminNotes" class="admin-notes">
        {{ card.adminNotes }}
      </p>

      <h5 v-if="pendingSales.length > 0" class="secondary-font">
        Pending Sales
      </h5>

      <section v-if="pendingSales.length > 0" :class="['pending-sales-list', { full: page }]">
        <pending-sales-item
          v-for="pendingSale in pendingSales"
          :id="pendingSale.itemId"
          :key="pendingSale.itemId"
          hide-graph
          :sale="pendingSale"
          @remove="removePendingSaleFromList"
          @update="updatePendingSale"
          @purgatory="sendToPurgatory"
        />
      </section>
    </template>

    <spinner v-else />
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { searchService } from '@/services';

import PendingSalesItem from '@/admin/PendingSalesItem';

export default {
  components: {
    PendingSalesItem,
  },

  props: {
    card: Object,
    cardId: String,
    page: Boolean,
  },

  data() {
    return {
      pendingSales: [],
      loaded: false,
      loading: false,
      refreshing: false,
    };
  },

  created() {
    this.load();
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    ...mapGetters({
      isAdmin: 'isAdmin',
    }),
  },

  methods: {
    async load() {
      this.loading = true;

      const filters = {
        employee: this.isAdmin ? 'all' : this.user.uid,
        cardId: this.cardId,
      };

      try {
        const data = await searchService.search({
          index: 'pendingsales',
          page: 1,
          limit: 50,
          filters,
          sort: 'date',
          direction: 'asc',
        });

        this.pendingSales = data.hits;
      } catch (e) {
        // swallow
      }

      this.loaded = true;
      this.loading = false;
    },

    sendToPurgatory(pendingSale) {
      const index = this.pendingSales.findIndex(({ itemId }) => itemId === pendingSale.itemId);

      if (index > -1) {
        this.pendingSales.splice(index, 1);
      }
    },

    removePendingSaleFromList(id) {
      this.pendingSales = this.pendingSales.filter(({ itemId }) => itemId !== id);
    },

    updatePendingSale(pendingSale) {
      const index = this.pendingSales.findIndex(({ itemId }) => itemId === pendingSale.itemId);

      if (index > -1) {
        this.$set(this.pendingSales, index, pendingSale);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-profile-admin {
  margin-bottom: $gp * 1.5;
}

h5 {
  margin-top: $gp;
}

.pending-sales-list {
  &.full {
    display: grid;
    grid-gap: $gp * 2;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.admin-notes {
  margin: $gp 0;
}
</style>
